import React, { useState, useRef, useEffect } from 'react';
import './NewsSection.css';

import news1Image from './assets/Not_04.jpg';
import news2Image from './assets/Not_01.jpg';
import news3Video from './assets/Not_07.webm';
import videoThumbnail from './assets/Papel_video_Not07.png'; // Thumbnail para vídeo

const NewsSection = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const videoRef = useRef(null);

  const newsCards = [
    {
      id: 1,
      title: "Angola Unida pela Paz: Memória, Reconciliação e Esperança no Futuro",
      content: "Em 4 de abril de 2002, Angola deu um passo histórico rumo à estabilidade com a assinatura do Memorando de Entendimento do Luena, que pôs fim à guerra civil e deu início a uma nova era de paz.",
      media: news1Image,
      mediaType: 'image'
    },
    {
      id: 2,
      title: "Celebrando Conquistas: Entrega de Certificados de Mérito",
      content: "A instituição realizou uma breve cerimônia, reconhecendo o desempenho acadêmico e a participação em projetos dos alunos. Os certificados foram entregues pela equipe diretiva em clima de celebração e reconhecimento..",
      media: news2Image,
      mediaType: 'image'
    },
    {
      id: 3,
      title: "Cerimónia da 7ª Edição da abertura do ceminário de formação de formadores Angola-Brazil",
      content: "Esta atividade marcou o início de mais uma etapa de cooperação e intercâmbio de experiências entre os dois países. O evento reuniu representantes institucionais, especialistas e formadores.",
      media: news3Video,
      thumbnail: videoThumbnail,
      mediaType: 'video'
    }
  ];

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleCardClick = (card) => {
    setSelectedCard(card);

    setTimeout(() => {
      document.querySelector('.modal-content')?.scrollTo(0, 0);
    }, 10);
  };

  const closeModal = () => {

    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    setSelectedCard(null);
  };

  return (
    <section className="news-section">
      <h2 className="section-title">Notícias e Atualizações</h2>
      
      <div className="cards-container">
        {newsCards.map((card) => (
          <div 
            key={card.id}
            className="news-card"
            onClick={() => handleCardClick(card)}
          >
            <div className="card-media-container">
              {card.mediaType === 'video' ? (
                <img 
                  src={card.thumbnail} 
                  alt={`Thumbnail para ${card.title}`}
                  className="card-media"
                  loading="lazy"
                />
              ) : (
                <img 
                  src={card.media} 
                  alt={card.title}
                  className="card-media"
                  loading="lazy"
                />
              )}
            </div>
            <h3 className="card-title">{card.title}</h3>
            <p className="card-content">{card.content}</p>
          </div>
        ))}
      </div>

      {selectedCard && (
        <div className="modal-overlay" onClick={closeModal}>
          <div 
            className="modal-content" 
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
          >
            <button 
              className="close-button" 
              onClick={closeModal}
              aria-label="Fechar modal"
            >
              ×
            </button>
            <h2 id="modal-title">{selectedCard.title}</h2>
            <p>{selectedCard.content}</p>
            
            <div className="modal-media-container">
              {selectedCard.mediaType === 'video' ? (
                <video 
                  ref={videoRef}
                  controls 
                  autoPlay
                  className="modal-media"
                  playsInline
                  aria-label={`Vídeo: ${selectedCard.title}`}
                >
                  <source src={selectedCard.media} type="video/mp4" />
                  Seu navegador não suporta o elemento de vídeo.
                </video>
              ) : (
                <img 
                  src={selectedCard.media} 
                  alt={selectedCard.title}
                  className="modal-media"
                />
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default NewsSection;